
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

export interface NavItem {
  title: string;
  icon: string;
  path: string;
}

@Component
export default class NavbarComponent extends Vue {
  @Prop({ required: true, validator: (value: boolean | null) => [true, false, null].includes(value) })
  readonly value!: boolean | null

  @Prop({ type: Array, default: () => [] })
  readonly items!: NavItem[]

  get isMobile () {
    return this.$vuetify.breakpoint.mdAndDown
  }

  updateOpenStatus (value: boolean) {
    this.$emit('input', value)
  }
}
